import React, { useState } from "react";
import Flexbox from "../../../components/utils/Flexbox";
import Image from "../../../components/utils/Image";
import "./styles.css";

export default function Message({ message, userId }) {
  const { text, image, createdAt, professional, customer } = message;
  const [flexbox, setFlexbox] = useState(false);

  let profile = {};
  let className = "";
  const created = new Date(createdAt);

  if (message.userId === customer._id) {
    profile = customer;
  } else {
    profile = professional;
  }

  if (message.userId === userId) {
    className = "my-message";
  } else {
    className = "guest-message";
  }

  return (
    <li>
      <div className={`message-item ${className}`}>
        {className === "guest-message" && (
          <Image
            src={profile.profilePhoto}
            fallbackSrc={
              "https://www.pngkit.com/png/detail/301-3012694_account-user-profile-avatar-comments-fa-user-circle.png"
            }
            className="profile-photo"
            alt="profile-photo"
          />
        )}
        <div className="message-content">
          <strong>
            {profile.firstName} {profile.lastName}
          </strong>
          {text ? (
            <p>{text}</p>
          ) : (
            <Image
              src={image}
              className="message-image"
              alt="chat-image"
              onClick={() => setFlexbox(true)}
              fallbackSrc={
                "https://drogariaguarulhos.com.br/media/catalog/product/placeholder/default/notfound.png"
              }
            />
          )}
          <span>
            {created.getHours() < 10
              ? `0${created.getHours()}`
              : created.getHours()}
            :
            {created.getMinutes() < 10
              ? `0${created.getMinutes()}`
              : created.getMinutes()}
          </span>
        </div>
        {className === "my-message" && (
          <>
            <Image
              src={profile.profilePhoto}
              fallbackSrc={
                "https://www.pngkit.com/png/detail/301-3012694_account-user-profile-avatar-comments-fa-user-circle.png"
              }
              className="profile-photo"
              alt="profile-photo"
            />
            <br />
          </>
        )}
      </div>
      {flexbox && <Flexbox image={image} setFlexbox={setFlexbox} />}
    </li>
  );
}
